import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ReactDOM from 'react-dom';

export default function PreloaderWithText(props) {
  if (!props.showPreloader) return null;

  return ReactDOM.createPortal(
    <Backdrop
      sx={(theme) => ({
        color: '#fff',
        zIndex: theme.zIndex.modal + 10, // always above dialogs
      })}
      open={true}
      className="loader_with_text"
    >
      <CircularProgress color="inherit" />
      {props.loadText && <p className="loading_text">{props.loadText}</p>}
    </Backdrop>,
    document.body
  );
}
